export default __webpack_public_path__ + "static/media/boxicons.cbd149c5.ttf";